// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

import { Component, OnInit, OnDestroy, AfterViewInit, Input, TemplateRef, ViewChild, Output, EventEmitter, HostBinding } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, MatSnackBar, MatDialog } from '@angular/material';
import { fadeInOut } from '../../services/animations';
import { FormBuilder, FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';
import { AlertService, MessageSeverity } from '../../services/alert.service';
import { AccountService } from "../../services/account.service";
import { Companie } from 'src/app/models/Companie.model';
import * as FileSaver from 'file-saver'; 

@Component({
    selector: 'companie',
    templateUrl: './companie.component.html',
    styleUrls: ['./companie.component.scss'],
    animations: [fadeInOut]
})

export class CompanieComponent
{
  private isSaving: boolean;
  private isNew: boolean;
  companieForm: FormGroup;
  companie: Companie;
  definireCompanie: boolean = false;

  denumire: string = '';
  cif: string = '';
  displayedColumns = ['denumire', 'cif', 'country', 'localitate', 'postalcode', 'adresa', 'stare', 'actions'];
  isDataLoaded: boolean = false;
  loadingIndicator: boolean = true;
  formResetToggle: boolean = true;
  _currentUserId: string;
  data: Companie[];
  dataSource: MatTableDataSource<Companie>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  //@HostListener('click')
  click() {
    this.accountService.toggle();
  }

  //

  afiseazaDate() {
    this.loadingIndicator = true;

    let denumire = this.denumire == null || this.denumire == "" ? "undefined" : this.denumire;
    let cif = this.cif == null || this.cif == "" ? "undefined" : this.cif;
    
    this.accountService
      .getCompaniiReprezentateList(denumire, cif)
      .subscribe(results => {
        
        let linii = results[0];

        let liniiReconverted = JSON.parse(JSON.stringify(linii));

        this.data = liniiReconverted;

        this.dataSource.data = this.data;

        this.isDataLoaded = true;

        setTimeout(() => { this.loadingIndicator = false; }, 1500);

      },
      error => {
        this.saveFailedHelperAfisareDate(error);
        this.loadingIndicator = false;
      });
  }

  private saveFailedHelperAfisareDate(error: any) {
    this.isSaving = false;
    this.alertService.stopLoadingMessage();
    this.alertService.showStickyMessage("Eroare afisare", error.error, MessageSeverity.error, error);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  reset() {
    this.denumire = '';
    this.cif = '';
  }

  blocareEditareCIF: boolean;
  modificareCompanie(companie: Companie) {
    this.definireCompanie = true;
    this.companie = companie;
    this.blocareEditareCIF = true;

    this.companie.stareafisare = this.companie.stare == "Neaprobat" ? "In curs de aprobare" : "Aprobat"; 
  }

  selectieCompanie(companie: Companie) {
    this.alertService.startLoadingMessage('Selecting company...');
    this.accountService.selectieCompanie(companie).subscribe(
      role => {
        this.saveSuccessHelper(companie, 'Company selected!');
        this.accountService.toggle();
      },
      error => this.saveFailedHelper(error));
    //this.valueChanged();
  }

  adaugare() {
    this.definireCompanie = true;
    this.companie = new Companie();
    this.blocareEditareCIF = false;
  }
  
  //

  afuConfig = {
    uploadAPI: {
      url: "https://example-file-upload-api"
    }
  };

  constructor(
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private accountService: AccountService,
  )
  {
    this.dataSource = new MatTableDataSource<Companie>();
    this.buildForm();
  }

  ngOnInit() {
    this.companie = new Companie();
    this.afiseazaDate();
  }
  
  save() {
    if (this.companieForm.valid) {
      this.accountService.newCompanie(this.companie).subscribe(
        role => this.saveSuccessHelper(this.companie, `Company information saved successfully!`),
        error => this.saveFailedHelper(error));
    }    
  }

  private saveSuccessHelper(companie?: Companie, mesaj?: string) {
    this.isSaving = false;
    this.alertService.stopLoadingMessage();

    this.alertService.showMessage("Success", mesaj, MessageSeverity.success);

    this.definireCompanie = false;
    this.afiseazaDate();
  }

  private saveFailedHelper(error: any) {
    this.isSaving = false;
    this.alertService.stopLoadingMessage();
    this.alertService.showStickyMessage("Save Error", "In procesul de salvare s-au produs urmatoarele erori: ", MessageSeverity.error, error);
    this.alertService.showStickyMessage(error, null, MessageSeverity.error);
  }

  private buildForm() {
    this.companieForm = this.formBuilder.group({
      tbDenumire: ['', [Validators.required, Validators.minLength(3)],],
      tbType: ['', Validators.required],
      tbCIF: ['', Validators.required],
      tbRegcom: ['', Validators.required],
      tbVAT: ['', Validators.required],
      tbCountry: ['', Validators.required],
      tbLocalitate: ['', Validators.required],
      tbAdresa: ['', Validators.required],
      tbPostalCode: ['', Validators.required],
      tbBanca: ['', Validators.required],
      tbContBancar: ['', Validators.required],
      tbTelefon: ['', Validators.required],
      tbStare: new FormControl({ value: '' })
    });
  }

  get tbVAT() {
    return this.companieForm.get('tbVAT');
  }

  get tbType() {
    return this.companieForm.get('tbType');
  }

  get tbDenumire() {
    return this.companieForm.get('tbDenumire');
  }

  get tbCIF() {
    return this.companieForm.get('tbCIF');
  }

  get tbRegcom() {
    return this.companieForm.get('tbRegcom');
  }

  get tbDocument() {
    return this.companieForm.get('tbDocument');
  }

  get tbLocalitate() {
    return this.companieForm.get('tbLocalitate');
  }

  get tbCountry() {
    return this.companieForm.get('tbCountry');
  }

  get tbAdresa() {
    return this.companieForm.get('tbAdresa');
  }

  get tbPostalCode() {
    return this.companieForm.get('tbPostalCode');
  }

  get tbBanca() {
    return this.companieForm.get('tbBanca');
  }

  get tbContBancar() {
    return this.companieForm.get('tbContBancar');
  }

  get tbTelefon() {
    return this.companieForm.get('tbTelefon');
  }

  get tbStare() {
    return this.companieForm.get('tbStare');
  }
  
  private cancel() {
    this.definireCompanie = false;
    this.afiseazaDate();
  }

  handleFileInputCI(files: FileList, mod: string) {
    if (mod == "1") {
      this.companie.documentCUI = files.item(0);
    }
    else if (mod == "2") {
      this.companie.documentCertificatFiscal = files.item(0);
    }
    else if (mod == "3") {
      this.companie.documentImputernicire = files.item(0);
    }
    else if (mod == "4") {
      this.companie.documentAprobareAdministratorJudiciar = files.item(0);
    }
    else if (mod == "5") {
      this.companie.documentAcordCompensareCuNerezidenti = files.item(0);
    }
  }

  incarcaFisier(mod: string) {
    const formData = new FormData();
    if (mod == "1" && this.companie.documentCUI == null) {
      this.alertService.stopLoadingMessage();
      this.alertService.showStickyMessage("Eroare incarcare fisier", "Fisierul nu este selectat!", MessageSeverity.error);
      return;
    }
    else if (mod == "2" && this.companie.documentCertificatFiscal == null) {
      this.alertService.stopLoadingMessage();
      this.alertService.showStickyMessage("Eroare incarcare fisier", "Fisierul nu este selectat!", MessageSeverity.error);
      return;
    }
    else if (mod == "3" && this.companie.documentImputernicire == null) {
      this.alertService.stopLoadingMessage();
      this.alertService.showStickyMessage("Eroare incarcare fisier", "Fisierul nu este selectat!", MessageSeverity.error);
      return;
    }
    else if (mod == "4" && this.companie.documentAprobareAdministratorJudiciar == null) {
      this.alertService.stopLoadingMessage();
      this.alertService.showStickyMessage("Eroare incarcare fisier", "Fisierul nu este selectat!", MessageSeverity.error);
      return;
    }
    else if (mod == "5" && this.companie.documentAcordCompensareCuNerezidenti == null) {
      this.alertService.stopLoadingMessage();
      this.alertService.showStickyMessage("Eroare incarcare fisier", "Fisierul nu este selectat!", MessageSeverity.error);
      return;
    }

    if (mod == "1") {
      formData.append('file', this.companie.documentCUI, this.companie.documentCUI.name);
    }
    else if (mod == "2") {
      formData.append('file', this.companie.documentCertificatFiscal, this.companie.documentCertificatFiscal.name);
    }
    else if (mod == "3") {
      formData.append('file', this.companie.documentImputernicire, this.companie.documentImputernicire.name);
    }
    else if (mod == "4") {
      formData.append('file', this.companie.documentAprobareAdministratorJudiciar, this.companie.documentAprobareAdministratorJudiciar.name);
    }
    else if (mod == "5") {
      formData.append('file', this.companie.documentAcordCompensareCuNerezidenti, this.companie.documentAcordCompensareCuNerezidenti.name);
    }

    this.accountService.uploadFisierDocumentCompanie(this.companie.reprezentantid, this.companie.id, formData, mod).subscribe((result) => {
      this.alertService.stopLoadingMessage();
      this.alertService.showMessage("Incarcare fisier", "Fisier incarcat cu succes!", MessageSeverity.success);

      if (mod == "1") {
        this.companie.fisierCUI = "abcd";
      }
      else if (mod == "2") {
        this.companie.fisierCertificatFiscal = "abcd";
      }
      else if (mod == "3") {
        this.companie.fisierImputernicire = "abcd";
      }
      else if (mod == "4") {
        this.companie.fisierAprobareAdministratorJudiciar = "abcd";
      }
      else if (mod == "5") {
        this.companie.fisierAcordCompensareCuNerezidenti = "abcd";
      }

    },
      error => {
        this.alertService.stopLoadingMessage();
        this.alertService.showStickyMessage("Eroare incarcare fisier", "In procesul de incarcare s-au produs urmatoarele erori: ", MessageSeverity.error, error);
        this.alertService.showStickyMessage(error, null, MessageSeverity.error);
      });
  }

  descarcaFisier(mod: string) {
    this.accountService.downloadDocumentCompanie(this.companie.reprezentantid, this.companie.id, mod).subscribe(result => {
      let blob = new Blob(result, {
        type: 'application/pdf' // must match the Accept type
      });

      let filename = 'Document_' + mod + '.pdf';
      FileSaver.saveAs(blob, filename);
    });
  }
}
